/// <reference path="../../lib/app.d.ts" />

interface Error
{
	field: FieldBase;
	error: string;
}

export function initialize($root : JQuery)
{
	const $items = $root.find("form.sxc-form:not(.sxcf-js)");
	$items.each((idx, item) => {
		new Form($(item));
	});
}

export class Form
{
	constructor(private $root : JQuery)
	{
		$root.addClass("sxcf-js");
		this.$root.data("sxcf", this);
		this.$root.attr("novalidate", "novalidate");

		$root.find(".sxcf-textfield")
			.each((idx, item) => {TextField.apply($(item))});

		$root.find(".sxcf-textarea")
			.each((idx, item) => {TextArea.apply($(item))});

		$root.find(".sxcf-checkbox")
			.each((idx, item) => {CheckBox.apply($(item))});

		$root.find(".sxcf-select")
			.each((idx, item) => {SelectField.apply($(item))});
	}

	validate()
	{
		const errors = [];

		this.$root.find(".sxcf-textfield, .sxcf-select, .sxcf-textarea, .sxcf-checkbox").each((idx, item) =>
		{
			let handler:FieldBase;

			if ($(item).hasClass("sxcf-textfield"))
				handler = TextField.apply($(item));
			else if ($(item).hasClass("sxcf-checkbox"))
				handler = CheckBox.apply($(item));
			else if ($(item).hasClass("sxcf-textarea"))
				handler = TextArea.apply($(item));
			else if ($(item).hasClass("sxcf-select"))
				handler = SelectField.apply($(item));

			if (handler) {
				let res = handler.validate(true);
				res.forEach((error) => errors.push({field: handler, error: error}));
			}
		});

		return errors;
	}

	triggerError(err : string, $cancelRoot : JQuery = null)
	{
		const $buttonCnt = this.$root.find(".sxcf-button-container");
		$buttonCnt.addClass("sxcf-has-error");

		$buttonCnt.find(".errors").addClass("visible");
		$buttonCnt.find(".errors .error").removeClass("visible");

		if (err)
		{
			let $err = $buttonCnt.find(".errors .error." + err);
			if ($err.length) {
				$err.addClass("visible");
			} else {
				$buttonCnt.find(".errors .error.default").addClass("visible");
			}

			($cancelRoot || this.$root).one("click", (e) => {
				e.preventDefault();
				e.stopImmediatePropagation();
				this.triggerError(null);
			})
		}
		else
		{
			$buttonCnt.find(".errors").removeClass("visible");
			$buttonCnt.removeClass("sxcf-has-error");
			$buttonCnt.find(".error").removeClass("visible");
		}
	}
}

export class FieldBase
{
	//protected $nativeElem : JQuery;
	protected initialized = false;
	protected checks = [];

	protected validateResult = [];
	protected customErrors = [];

	protected prevValue;

	static apply($root : JQuery, getHandler : () => FieldBase)
	{
		let handler : FieldBase = <any> $root.data("sxcf");

		if (!handler)
		{
			handler = getHandler();
			$root.data("sxcf", handler);
			handler.$nativeElem.data("sxcf", handler)
		}

		return handler;
	}

	constructor(protected $root : JQuery, protected $nativeElem : JQuery)
	{
		this.$root.addClass("sxcf-js");
		this.$nativeElem.addClass("sxcf-js");
	}

	focus() {
		this.$nativeElem.focus();
	}

	addCustomCheck(check : Function)
	{
		this.checks.push(check);
	}

	reset() {}

	validate(val = null)
	{
		if (this.$nativeElem.prop("disabled")) return [];

		let errors = [];
		if (this.$nativeElem.prop("required") && (val === false || val === "")) {

			errors.push("required");
		}

		const minLength = parseInt(this.$nativeElem.attr("minlength"), 10);

		if (minLength && val.length < minLength) {
			errors.push("tooshort");
		}

		for(let i = 0; i < this.checks.length; i++) {
			errors = errors.concat(this.checks[i]());
		}

		this.validateResult = errors;
		return errors;
	}

	addError(name : string, text : string)
	{
		let $errors = this.$root.find(".errors");
		$errors.find(".error." + name).remove();
		$errors.append($("<div class='error " + name + "' />").text(text));
	}

	triggerError(err)
	{
		if (this.validateResult.indexOf(err) === -1) {
			this.validateResult.push(err);
		}

		this.showErrors();
	}

	showErrors()
	{
		let errors = []
			.concat(this.validateResult)
			.concat(this.customErrors);

		if (errors.length)
		{
			this.$nativeElem.addClass("sxcf-has-error");

			this.$root.find(".errors").addClass("visible");
			this.$root.find(".errors .error").removeClass("visible");

			errors.forEach((item) => {
				if (this.$root.find(".errors .error." + item).length) {
					this.$root.find(".errors .error." + item).addClass("visible");
				} else {
					this.$root.find(".errors .error.default").addClass("visible");
				}
			});
		}
		else
		{
			this.$root.find(".errors").removeClass("visible");
			this.$nativeElem.removeClass("sxcf-has-error");
			this.$root.find(".error").removeClass("visible");
		}
	}

	addCustomError(error)
	{
		if (this.customErrors.indexOf(error) === -1)
			this.customErrors.push(error);
	}

	removeCustomError(error)
	{
		for (let i=this.customErrors.length-1; i>=0; i--) {
			if (this.customErrors[i] == error) {
				this.customErrors.splice(i, 1);
			}
		}
	}
}

class CheckBox extends FieldBase
{
	static apply($root : JQuery)
	{
		return FieldBase.apply($root, () => new CheckBox($root));
	}

	constructor(protected $root : JQuery)
	{
		super($root, $root.find("input"));

		this.$nativeElem
			.blur(this.validate.bind(this))
			.change(this.validate.bind(this));

		this.prevValue = this.$nativeElem.is(":checked") ? "1" : null;
	}

	focus()
	{
		this.$nativeElem.focus();
	}

	validate()
	{
		let val = this.$nativeElem.is(":checked") ? "1" : null;
		this.prevValue = val;
		let errors = super.validate(val);
		this.validateResult = errors;
		this.showErrors();
		return errors;
	}
}

class TextField extends FieldBase
{
	static apply($root : JQuery)
	{
		return FieldBase.apply($root, () => new TextField($root));
	}

	constructor(protected $root : JQuery, nativeElem : JQuery = null)
	{
		super($root, nativeElem || $root.find("input"));

		this.$nativeElem
			.blur(this.onChange.bind(this))
			.change(this.onChange.bind(this));

		this.prevValue = this.$nativeElem.val();
		this.updateLabel();
	}

	clear()
	{

	}

	reset()
	{
		this.$nativeElem.val("").change();
		this.validateResult = [];
		this.customErrors = [];

		this.updateLabel();
		this.showErrors();
	}

	onChange()
	{
		this.updateLabel();
		let val = this.$nativeElem.val();
		if (!this.prevValue || this.prevValue !== val) {
			this.prevValue = val;
			this.validate();
		}
	}

	updateLabel()
	{
		let val = this.$nativeElem.val();
		this.$nativeElem[val ? "addClass" : "removeClass"]("sxcf-has-content")
	}

	validate()
	{
		let val = this.$nativeElem.val();
		this.prevValue = val;
		let errors = [];

		errors = errors.concat(super.validate(val));

		if (this.$nativeElem.attr("type") === "email" && errors.indexOf("required") === -1) {
			let re = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
			if (!re.test(val)) {
				errors.push("invalid");
			}
		}

		this.validateResult = errors;
		this.showErrors();
		return errors;
	}
}

class TextArea extends TextField
{
	static apply($root : JQuery)
	{
		return FieldBase.apply($root, () => new TextArea($root));
	}

	constructor(protected $root : JQuery)
	{
		super($root, $root.find("textarea"));

		this.$nativeElem
			.blur(this.onChange.bind(this))
			.change(this.onChange.bind(this));

		this.updateLabel();
	}
}

class SelectField extends FieldBase
{
	private $head : JQuery;
	private $list : JQuery;
	private $listW : JQuery;
	private lastFocusTime : number = 0;

	static apply($root : JQuery) : FieldBase
	{
		return FieldBase.apply($root, () => new SelectField($root));
	}

	constructor(protected $root : JQuery)
	{
		super($root, $root.find("select"));

		this.$root
			.blur(() => {this.close();})
			.focus((e) => {
				this.lastFocusTime = Date.now();
				this.open();
				return false;
			});

		this.$nativeElem
			.change(this.onChange.bind(this));

		this.prevValue = this.$nativeElem.val();

		this.$root.attr("tabindex", "0");
		this.$nativeElem.attr("tabindex", "-1");

		let dsmLock = false;

		this.$nativeElem.on("DOMSubtreeModified", (e) => {
			if (dsmLock) return;
			dsmLock = true;
			this.disable(this.$nativeElem.prop("disabled"));
			dsmLock = false;
		});

		this.$nativeElem.focus(() => {
			setTimeout(() => this.$root[0].focus(), 100);
		});

		if (this.$nativeElem.prop("disabled")) {
			this.disable(true);
		}

		this.$head = $("<div />").addClass("select-head").appendTo(this.$root);
		this.$listW = $("<div />").addClass("select-list").appendTo(this.$root);
		this.$list = $("<div />").addClass("select-list-inner").appendTo(this.$listW);

		this.$root.find("label, .select-head").on("click", (e) => {

			if (this.lastFocusTime + 1000 > Date.now()) return;

			if (this.$root.hasClass("sxcf-opened")) {
				this.close();
			} else {
				this.open();
			}
		});

		this.$list.on("click", ".sxcf-option", (e) => {
			let $option = $(e.currentTarget);
			this.select($option.attr("value"));
			this.close();
		});

		this.$list.on("mouseenter", ".sxcf-option", (e) => {
			let $option = $(e.currentTarget);
			this.$list.find(".sxcf-option").removeClass("selected");
			$option.addClass("selected");
		});

		this.updateHead();
		this.updateList();

		this.$root.keydown(this.keyDownHandler.bind(this));
		this.$root.keypress(this.keyPressHandler.bind(this));

		this.$root.addClass("sxcf-js");

	}

	focus() {
		this.$root.focus();
	}

	close() {
		this.$root.removeClass("sxcf-opened");

		let $item = this.$list.find(".selected");
		let val = $item.attr("value");
		if ($item.length) {
			this.select(val);
		}
	}

	disable(disabled)
	{
		if (disabled) {
			this.$root.attr("disabled", "disabled");
		} else {
			this.$root.removeAttr("disabled");
		}
		this.$root.attr("tabindex", disabled ? "-1" : "0");
	}

	open()
	{
		if (this.$root.hasClass("sxcf-opened")) {return;}
		if (this.$nativeElem.prop("disabled")) return;
		this.$root.addClass("sxcf-opened");
		this.fixScroll("up");
	}

	select(val)
	{
		this.$nativeElem.val(val);
		this.$nativeElem.change();
		this.onChange();

		if (this.prevValue !== val) {
			this.prevValue = val;
			this.validate();
		}
	}

	updateHead()
	{
		let val = this.$nativeElem.val();

		if (val !== "") {
			let text = this.$nativeElem.find("option[value=" + val + "]").text();
			this.$head.text(text);
			this.$nativeElem.addClass("sxcf-has-content")
		} else {
			this.$nativeElem.removeClass("sxcf-has-content")
		}
	}

	updateList()
	{
		this.$list.empty();
		this.$nativeElem.find("option").each((i, option) =>
		{
			let $option = $(option);
			let val = $option.attr("value");
			if (!val) return;

			$("<div />")
				.addClass("sxcf-option")
				.text($option.text())
				.appendTo(this.$list)
				.attr("value", val);
		})
	}

	onChange()
	{
		let val = this.$nativeElem.val();
		this.$nativeElem[val ? "addClass" : "removeClass"]("sxcf-has-content");
		this.$head.text(this.$nativeElem.find("option[value="+val+"]").text());

		if (val !== this.prevValue) {
			this.prevValue = val;
			this.validate();
		}
	}

	validate()
	{
		let val = this.$nativeElem.val();
		this.prevValue = val;

		let errors = [];
		if (this.$nativeElem.prop("disabled")) return [];

		errors = errors.concat(super.validate(val));

		this.validateResult = errors;
		this.showErrors();
		return errors;
	}

	fixScroll (direction)
	{
		let $selected = this.$list.find(".selected");
		if (!$selected.length) return;

		let pTop = this.$list.scrollTop();
		let pHeight = this.$list.innerHeight();
		let pBottom = pTop + pHeight;

		let sTop = pTop + $selected.position().top;
		let sHeight = $selected.outerHeight();
		let sBottom = sTop + sHeight;

		if (pBottom < sBottom || pTop > sTop) {
			let scrollTo = 0;
			if (direction === "up") {scrollTo = sTop;}
			else {scrollTo = sBottom - pHeight;}
			this.$list.scrollTop(scrollTo);
		}
	}

	selectFirst()
	{
		this.$list.find(".sxcf-option").removeClass("selected");
		this.$list.find(".sxcf-option:eq(0)").addClass("selected");
		this.fixScroll("down");
	}

	private inputBuffer : string;
	private lastInput : number = 0;

	keyPressHandler(e)
	{
		if (!this.$root.hasClass("sxcf-opened")) return;
		let charTyped = String.fromCharCode(e.which || e.keyCode).toLowerCase();

		if (this.lastInput < Date.now() - 2000) this.inputBuffer = "";
		this.inputBuffer += charTyped;
		this.lastInput = Date.now();

		//let $selected = this.$list.find(".sxcf-option.selected");

		let $foundItem = null;
		this.$list.find(".sxcf-option").each((i, item) => {
			let $item = $(item);
			if ($item.text().toLowerCase().indexOf(this.inputBuffer) === 0) {
				$foundItem = $item;
				return false;
			}
		});

		if ($foundItem) {
			this.$list.find(".sxcf-option.selected").removeClass("selected");
			$foundItem.addClass("selected");
			this.fixScroll("down");
		}
	}

	keyDownHandler(e)
	{
		let opened = this.$root.hasClass("sxcf-opened");

		let handled = true;
		switch(e.keyCode)
		{
			case 32:
			case 13:
				if (opened) {
					let $item = this.$list.find(".selected");
					this.select($item.attr("value"));
					this.close();
				} else {
					this.open();
				}
				break;

			case 40:
				if (opened) {
					let $item = this.$list.find(".selected");
					if ($item.length) {
						if ($item.next() && $item.next().length) {
							$item.removeClass("selected").next().addClass("selected");
							this.fixScroll("down");
						}
					} else {
						this.selectFirst();
					}
				} else {
					this.open();
					this.selectFirst();
				}
				break;

			case 38:
				if (opened) {
					let $item = this.$list.find(".selected");
					if ($item.length) {
						if ($item.prev() && $item.prev().length) {
							$item.removeClass("selected").prev().addClass("selected");
							this.fixScroll("up");
						}
					} else {
						this.selectFirst();
					}
				} else {
					this.open();
					this.selectFirst();
				}

				break;

			default:
				handled = false;
				break;
		}

		if (handled) {
			e.preventDefault();
		}
	}
}

const form = {initialize, Form, FieldBase, CheckBox, TextField, TextArea, SelectField};
export default form;
